




























import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "../root/modal";
export default Vue.extend({
  components: {
    Modal
  },
  props: ["modalData"],
  setup() {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem", // 76
      height: "47rem", // 76
      backdropDismiss: true
    };

    return {
      config
    };
  }
});
